/*
 * Bild-Slider in der Produktkarte.
 * Gewischt wird per scroll-snap, das Skript kümmert sich nur um Pfeile und Punkte.
 * Bewusst nicht Dawns SliderComponent: die erwartet eine eigene Button-Struktur
 * und einen Seitenzähler, und sie steigt ohne beide Buttons komplett aus.
 */
class CardProductSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.card__slides');
    this.slides = Array.from(this.querySelectorAll('.card__slide'));
    this.dots = Array.from(this.querySelectorAll('.card__slider-dot'));
    this.prevButton = this.querySelector('.card__slider-button--prev');
    this.nextButton = this.querySelector('.card__slider-button--next');

    this.card = this.closest('.card');

    if (!this.track || this.slides.length < 2) return;

    this.prevButton?.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton?.addEventListener('click', this.onButtonClick.bind(this));
    this.track.addEventListener('scroll', this.onScroll.bind(this), { passive: true });

    this.setCurrent(0);
  }

  get step() {
    return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
  }

  onButtonClick(event) {
    // Ohne das würde der Klick beim Link der Karte landen
    event.preventDefault();
    event.stopPropagation();

    const direction = event.currentTarget.name === 'next' ? 1 : -1;
    this.track.scrollTo({ left: this.track.scrollLeft + direction * this.step, behavior: 'smooth' });
  }

  onScroll() {
    if (this.scrollFrame) return;

    this.scrollFrame = requestAnimationFrame(() => {
      this.scrollFrame = null;

      // Badges verdecken das Bild, sobald gewischt wird. Zurück am Anfang: wieder da.
      this.card?.classList.toggle('card--sliding', this.track.scrollLeft > 8);

      const step = this.step;
      if (step <= 0) return;

      this.setCurrent(Math.round(this.track.scrollLeft / step));
    });
  }

  setCurrent(index) {
    this.dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('card__slider-dot--active', dotIndex === index);
    });

    if (this.prevButton) this.prevButton.disabled = index <= 0;
    if (this.nextButton) this.nextButton.disabled = index >= this.slides.length - 1;
  }
}

customElements.define('card-product-slider', CardProductSlider);
